import React, { useState } from "react";

import ApplyGreenTutor from "./ApplyGreenTutor";
import ShortlistedGreenTutor from "./ShortlistedGreenTutor";
import SelectedGreenTutor from "./SelectedGreenTutor";
import AppointedGreenTutor from "./AppointedGreenTutor";
import CancelledGreenTutor from "./CancelledGreenTutor";
import DashSubGreenTutor from "./DashSubGreenTutor";

const TutorDashBoardGreen = () => {
  const [activeTab, setActiveTab] = useState(5); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <ApplyGreenTutor></ApplyGreenTutor>;
      case 1:
        return <ShortlistedGreenTutor></ShortlistedGreenTutor>;
      case 2:
        return <SelectedGreenTutor></SelectedGreenTutor>;
      case 3:
        return <AppointedGreenTutor></AppointedGreenTutor>;
      case 4:
        return <CancelledGreenTutor></CancelledGreenTutor>;
      case 5:
        return <DashSubGreenTutor></DashSubGreenTutor>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-100">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          Dashboard
        </h2>
      </div>
      <div className="m-5 flex flex-row gap-5">
        <button
          onClick={() => setActiveTab(5)}
          className={activeTab === 5 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Dashboard
        </button>
        <button
          onClick={() => setActiveTab(0)}
          className={activeTab === 0 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Applied
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={activeTab === 1 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Shortlisted
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={activeTab === 2 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Selected
        </button>
        <button
          onClick={() => setActiveTab(3)}
          className={activeTab === 3 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Appointed
        </button>
        <button
          onClick={() => setActiveTab(4)}
          className={activeTab === 4 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Cancelled
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default TutorDashBoardGreen;
